import {jobStatuses, sdoNs, pages, jobTypes} from './constants-enumerate';
import './sdo-user-jobs';
import './session-sdo';
import {storeInstance} from '@aofl/store/dist/legacy';
import {ApiService, apiRequestInstance} from './api-service';
import {routerInstance} from '@aofl/router';
import {Toast} from './toast';
import UserJobAlert from './user-job-alert';
import {html} from 'lit-html';

const doneStatuses = [jobStatuses.DONE, jobStatuses.FAILED, jobStatuses.CANCELED];

class UserJobs {
  delay = this.getDelay();
  interval = null;
  trackedJobs = {};
  jobAlerts = {};
  lastHash = '';

  static isDone(job) {
    return doneStatuses.indexOf(job.status) > -1;
  }

  getDelay() {
    let delay = localStorage.getItem('user-job-delay') || 5000;
    // setting a minimum of 5000 so the frontend doesn't crash
    if (delay < 5000) {
      delay = 5000;
    }
    return delay;
  }

  pause() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  resume() {
    this.pause();
    this.interval = setInterval(() => this.getJobs(), this.delay);
  }

  processTrackedJobs(jobs) {
    let shouldRefresh = false;
    for (let i = 0; i < jobs.length; i++) {
      const job = jobs[i];
      if (typeof this.trackedJobs[job.id] !== 'undefined' &&
        this.trackedJobs[job.id] !== jobStatuses.DONE && job.status === jobStatuses.DONE) {
        shouldRefresh = true;
      }
      this.trackedJobs[job.id] = job.status;
    }

    if (shouldRefresh) {
      const currentRoute = routerInstance.currentRoute;
      if (currentRoute.to.indexOf(pages.ADMIN_SEARCH) > -1) {
        apiRequestInstance.purgeCache();
        routerInstance.navigate(currentRoute.to, {forceReload: true});
      }
    }
  }

  processJobAlerts(jobs) {
    for (let i = 0; i < jobs.length; i++) {
      const job = jobs[i];
      const cachedJob = this.jobAlerts[job.id];
      let alert = void 0;

      if (typeof cachedJob !== 'undefined' && cachedJob.status !== job.status) {
        if (typeof cachedJob.alert !== 'undefined') {
          Toast.remove(cachedJob.alert);
        }
        const timeout = this.getJobAlertTimeout(job);
        const options = {timeout};
        const jobStatusComponent = html([`<${UserJobAlert.is} job-id="${job.id}"></${UserJobAlert.is}>`]);
        if (job.status === jobStatuses.FAILED) {
          alert = Toast.error(jobStatusComponent, '', options);
        } else if (job.status === jobStatuses.CANCELED) {
          alert = Toast.notification(jobStatusComponent, '', options);
        } else if (UserJobs.isDone(job)) {
          if (
            (job.job_type === jobTypes.TEACHER_INVITES || job.job_type === jobTypes.INVITES)
            &&
            (job.result.fatal_errors + job.result.invalid_emails) > 0
          ) {
            Toast.error(html([`<${UserJobAlert.is} job-id="${job.id}" invalid=1></${UserJobAlert.is}>`]), '', options);
          }

          alert = Toast.success(jobStatusComponent, '', options);
        } else {
          alert = Toast.warning(jobStatusComponent, '', options);
        }
      }
      this.jobAlerts[job.id] = {
        alert,
        status: job.status
      };
    }
  }

  getJobAlertTimeout(job) {
    const isRosterType = [jobTypes.ROSTER_FULL, jobTypes.ROSTER_NEW].indexOf(job.job_type) !== -1;
    const isExternalRosterType = isRosterType && job.params.data_type !== 'aofl' && job.params.data_type !== 'oneroster';
    return isExternalRosterType && (job.status === jobStatuses.DONE || job.status === jobStatuses.FAILED) ? 0 : 4000;
  }

  async getJobs() {
    const loggedIn = storeInstance.getState()[sdoNs.SESSION].loggedIn;
    if (!loggedIn) {
      clearInterval(this.interval);
      return;
    }
    const userJobs = await ApiService.userJobGetList([jobTypes.GENERATE_QR]);
    const newHash = JSON.stringify(userJobs.jobs);
    if (this.lastHash === newHash) {
      return;
    }
    this.lastHash = newHash;

    const cached = localStorage.getItem('dismissed_jobs');
    let dismissedJobs = [];
    if (cached !== null) {
      dismissedJobs = JSON.parse(cached);
    }

    let filteredJobs = [];
    userJobs.jobs.forEach((job) => {
      if (dismissedJobs.indexOf(job.id) < 0) {
        filteredJobs.push(job);
      }
    });
    this.processTrackedJobs(userJobs.jobs);
    this.processJobAlerts(filteredJobs);
    storeInstance.commit({
      namespace: sdoNs.USER_JOBS,
      mutationId: 'setJobs',
      payload: userJobs.jobs
    });
    const state = storeInstance.getState();

    const $activeRosterJob = state[sdoNs.USER_JOBS].$activeRosterJob;
    if (typeof $activeRosterJob.status === 'undefined' || $activeRosterJob.status === 'done') {
      await this.getRosterJobs();
    }

    this.delay = state[sdoNs.USER_JOBS].$activeJobs.length === 0 ? 15000 : this.getDelay();

    this.resume();
  }

  async getRosterJobs() {
    const rosterJobs = await ApiService.rosterJobGetList();
    storeInstance.commit({
      namespace: sdoNs.USER_JOBS,
      mutationId: 'setRosterJobs',
      payload: rosterJobs.jobs
    });
  }
}

const userJobs = new UserJobs();

export {
  userJobs,
  UserJobs
};
